import { createAction } from "@reduxjs/toolkit";

export const getOrganizationAppointmentListAction = createAction('organization/appointment/list', (payload) => ({ payload }))



